import BaseService from '@/ecm/common/BaseService.js';

class Office365Service {
  baseUrl = 'auto-import';
  getUserEmail = (refreshToken) => BaseService.post({ url: `${this.baseUrl}/office365/user-email`, data: refreshToken });
}
export default new Office365Service();